<template>
	<svg fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
	     viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" @click="$emit('icon-click')">
		<line x1="3" x2="21" y1="12" y2="12"></line>
		<line x1="3" x2="21" y1="6" y2="6"></line>
		<line x1="3" x2="21" y1="18" y2="18"></line>
	</svg>
</template>

<script>
// source: https://iconsvg.xyz/
export default {
	name: "Menu"
}
</script>
